import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ToolbarModule } from "primeng/toolbar";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";
import { DialogService } from "primeng/dynamicdialog";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { InputNumberModule } from "primeng/inputnumber";
import { AccordionModule } from "primeng/accordion";
import { DatePickerModule } from "primeng/datepicker";
import { AutoCompleteModule } from "primeng/autocomplete";
import { TableModule } from "primeng/table";
import { FileUploadModule } from "primeng/fileupload";
import { TooltipModule } from "primeng/tooltip";
import { BlockUIModule } from "primeng/blockui";
import { MultiSelectModule } from "primeng/multiselect";
import { CheckboxModule } from "primeng/checkbox";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SelectButtonModule } from "primeng/selectbutton";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { SelectModule } from "primeng/select";
import { SplitterModule } from "primeng/splitter";
import { TreeModule } from "primeng/tree";
import { TabsModule } from "primeng/tabs";

@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    ToastModule,
    DialogModule,
    ToolbarModule,
    InputTextModule,
    InputNumberModule,
    AutoCompleteModule,
    DatePickerModule,
    ButtonModule,
    InputTextModule,
    AccordionModule,
    TableModule,
    FileUploadModule,
    TooltipModule,
    BlockUIModule,
    MultiSelectModule,
    CheckboxModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    SelectButtonModule,
    SplitterModule,
    TreeModule,
    SelectModule,
    TabsModule,
  ],
  exports: [
    ButtonModule,
    ToastModule,
    DialogModule,
    ToolbarModule,
    InputTextModule,
    InputNumberModule,
    AutoCompleteModule,
    DatePickerModule,
    ButtonModule,
    InputTextModule,
    AccordionModule,
    TableModule,
    FileUploadModule,
    TooltipModule,
    BlockUIModule,
    MultiSelectModule,
    CheckboxModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    SplitterModule,
    TreeModule,
    SelectModule,
    TabsModule,
  ],
  providers: [MessageService, DialogService],
})
export class PrimeNgModule {}
